export default __webpack_public_path__ + "static/media/mac1.417fab28.png";